module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley-rw"
  }, [_c('section', {
    staticClass: "frontmatter-rw Dedication-rw auto-rw page-open-left-rw",
    attrs: {
      "epub:type": "frontmatter dedication",
      "id": "dedication"
    }
  }, [_c('h1', {
    staticClass: "dedication-title"
  }), _vm._v(" "), _c('p', {
    staticClass: "dedication"
  }, [_c('a', {
    attrs: {
      "id": "page-ix"
    }
  }), _c('em', [_vm._v("To my Savior King, You taught me how to dance again.")])]), _vm._v(" "), _c('p', {
    staticClass: "dedication1"
  }, [_c('em', [_vm._v("To my husband, my knight, I’ll love you until the end of time.")])]), _vm._v(" "), _c('p', {
    staticClass: "dedication1"
  }, [_c('em', [_vm._v("To Daniel, Samantha, and Hayley, the three most thoughtful, caring, perfect beings in my world.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-793dbbbe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dedication.vue
// module id = 66
// module chunks = 0